// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DtzaAgInSPJSZAkYZUjd {
    max-width: 350px;
    margin: 0px auto 0px;
    padding-top: 8px;
    width: auto;
}

.gWkUZSMAmYLKRDjsJI8r {
    margin-top: 6px;
}

.yZwLXNLtwi4mzpVhYXWf {
    margin: 20px 5px 0 0 !important;
}

.yt1KTYSAsViHgtGUnrTK {
    position: relative;
    height: 0;
    overflow: hidden;
    flex-basis: initial !important;
    z-index: -1;
}

.ojmch6NIedsWqwzbPMUV {
    margin-bottom: 16px;
    padding-bottom: 16px;
}

.RcWhOEgiX6gVWP8CHXw8 {
    font-size: 12px;
    line-height: 16px;
    color: #32445a;
    font-weight: 500;
    margin-top: -10px;
    margin-left: 8px;
    margin-bottom: 40px;
}

.ffLaCqzJvkdRN6lUu_FR {
    width: 100%;
    max-width: 300px;
    box-sizing: border-box;
}

.dW2LGpmFplvyCNmZ8oPy {
    padding-top: 16px;
}

.cN_jqselmUGEPwm_P3Y3 {
    box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/login/components/Login.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".form {\n    max-width: 350px;\n    margin: 0px auto 0px;\n    padding-top: 8px;\n    width: auto;\n}\n\n.button {\n    margin-top: 6px;\n}\n\n.checkbox {\n    margin: 20px 5px 0 0 !important;\n}\n\n.invisibleButFillable {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    flex-basis: initial !important;\n    z-index: -1;\n}\n\n.loginCard {\n    margin-bottom: 16px;\n    padding-bottom: 16px;\n}\n\n.rememberLabel {\n    font-size: 12px;\n    line-height: 16px;\n    color: #32445a;\n    font-weight: 500;\n    margin-top: -10px;\n    margin-left: 8px;\n    margin-bottom: 40px;\n}\n\n.loginButton {\n    width: 100%;\n    max-width: 300px;\n    box-sizing: border-box;\n}\n\n.codeMessage {\n    padding-top: 16px;\n}\n\n.borderlessCard {\n    box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `DtzaAgInSPJSZAkYZUjd`,
	"button": `gWkUZSMAmYLKRDjsJI8r`,
	"checkbox": `yZwLXNLtwi4mzpVhYXWf`,
	"invisibleButFillable": `yt1KTYSAsViHgtGUnrTK`,
	"loginCard": `ojmch6NIedsWqwzbPMUV`,
	"rememberLabel": `RcWhOEgiX6gVWP8CHXw8`,
	"loginButton": `ffLaCqzJvkdRN6lUu_FR`,
	"codeMessage": `dW2LGpmFplvyCNmZ8oPy`,
	"borderlessCard": `cN_jqselmUGEPwm_P3Y3`
};
export default ___CSS_LOADER_EXPORT___;
